const {LitElement, html, ref, createRef} = window.globalLit;

customElements.define('element-selector', class ElementSelectorElement extends LitElement {
    static properties = { 
        value: { type: Object },
        readonly: { type: Boolean, attribute: 'readonly' },
    };

    spanRef = createRef();
    popupRef = createRef();
    popperInstance = null;

    constructor() {
        super();
        this.readonly = false;
    }

    createRenderRoot() { return this; }

    connectedCallback() {
        super.connectedCallback();
        this._onDocumentClickBinded = this._onDocumentClick.bind(this);
        document.addEventListener('click', this._onDocumentClickBinded);
    }

    disconnectedCallback() {
        super.disconnectedCallback();
        document.removeEventListener('click', this._onDocumentClickBinded);
        this.popperInstance.destroy();
    }

    firstUpdated() {
        this.popperInstance = Popper.createPopper(
            this.spanRef.value,
            this.popupRef.value
        );
    }

    _onDocumentClick(event) {
        let isSpanOrPopup = this.spanRef.value.contains(event.target) || this.popupRef.value.contains(event.target);
        if (!isSpanOrPopup) {
            this.popupRef.value.removeAttribute('data-show');
        }
    }

    _onBadgeClick() {
        if (this.readonly) {
            return;
        }

        if (!this.popupRef.value.hasAttribute('data-show')) {
            this.popupRef.value.setAttribute('data-show', '');
            setTimeout(() => 
                this.querySelector('input').focus()
            , 10);
        } else {
            this.popupRef.value.removeAttribute('data-show');
        }

        this.popperInstance.update();
    }

    _onSelectorInput(event) {
        let newValue = Object.assign({}, this.value, { 
            text: event.target.value 
        });

        this.dispatchEvent(new CustomEvent('selectorchange', { 
            detail: newValue,
            composed: true,
            bubbles: true,
        }));
    }

    _onTabClick(locator, event) {
        if (locator === this.value.locator) {
            return;
        }

        let newValue = Object.assign({}, this.value, { 
            // text:    '',
            locator: locator
        });

        this.dispatchEvent(new CustomEvent('selectorchange', { 
            detail: newValue,
            composed: true,
            bubbles: true,
        }));
    }
    
    render() {
        return html`
            <a href="javascript:void(0)" ${ref(this.spanRef)}
                @click="${this._onBadgeClick}"
                class="badge bg-secondary-subtle text-secondary">
                ${
                    this.value.locator && this.value.text
                        ? html`${this.value.locator}:${this.value.text}`
                        : html`<em>click to select</em>`
                }
            </a>

            <div ${ref(this.popupRef)}
                role="tooltip" 
                class="element-selector__popup"
                >
                <div class="card shadow">
                    <div class="card-body p-2">
                        <ul class="nav nav-underline" style="margin-bottom:5px;">
                            <li class="nav-item">
                                <a class="nav-link ${this.value.locator === 'css' && 'active'}"
                                    href="javascript:void(0);" @click=${this._onTabClick.bind(this, 'css')}>By CSS</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link ${this.value.locator === 'getByText' && 'active'}"
                                    href="javascript:void(0);" @click=${this._onTabClick.bind(this, 'getByText')}>By text</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link ${this.value.locator === 'getByPlaceholder' && 'active'}"
                                    href="javascript:void(0);" @click=${this._onTabClick.bind(this, 'getByPlaceholder')}>By placeholder</a>
                            </li>
                        </ul>
                        <div class="tab-content">
                            ${(() => {
                                if (this.value.locator === 'css') {
                                    return html`
                                        <div class="tab-pane active" role="tabpanel" tabindex="0">
                                            <input 
                                                @input=${this._onSelectorInput}
                                                .value=${this.value.text || ''}
                                                type="text" class="form-control form-control-sm">
                                        </div>
                                    `;
                                }
                                else if (this.value.locator === 'getByText') {
                                    return html`
                                        <div class="tab-pane active" role="tabpanel" tabindex="0">
                                            <input 
                                                @input=${this._onSelectorInput}
                                                .value=${this.value.text || ''}
                                                type="text" class="form-control form-control-sm">
                                        </div>
                                    `;
                                }
                                else if (this.value.locator === 'getByPlaceholder') {
                                    return html`
                                        <div class="tab-pane active" role="tabpanel" tabindex="0">
                                            <input 
                                                @input=${this._onSelectorInput}
                                                .value=${this.value.text || ''}
                                                type="text" class="form-control form-control-sm">
                                        </div>
                                    `;
                                }
                            })()}
                        </div>

                    </div>
                </div>
            </div>
        `;
    }

});


{/* <ul class="nav nav-underline">
    <li class="nav-item">
        <a class="nav-link active" aria-current="page" href="#" data-bs-toggle="tab" data-bs-target="#home-tab-pane">By selector</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" href="#" data-bs-toggle="tab" data-bs-target="#profile-tab-pane">By text</a>
    </li>
    <li class="nav-item">
        <a class="nav-link" href="#" data-bs-toggle="tab" data-bs-target="#contact-tab-pane" >Link</a>
    </li>
</ul>

<div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="home-tab-pane" role="tabpanel" aria-labelledby="home-tab" tabindex="0">
        Hola mundo

    </div>
    <div class="tab-pane fade" id="profile-tab-pane" role="tabpanel" aria-labelledby="profile-tab" tabindex="0">y</div>
</div> */}